import { Box, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { DataLoadSegment, ListTable, PaginationByIndex, Section, TableEmptyState } from 'js/components'
import { useTaskSubscriber } from 'js/hooks'
import { SimpleMap } from 'js/utils'
import React, { ReactElement } from 'react'
import { RestModels, RestTypes } from 'tradehub-api-js'
import LiquidationEngineRow from './LiquidationEngineRow'

export interface LiquidationEngineProps {
  filterStatus: boolean
  orders?: RestTypes.ResultsMinMax<RestModels.Order>
  title: string
  action: any
  markets: SimpleMap<RestModels.Market>
  loadName: string[]
  loadCondition?: boolean
  sectionClass?: string
}

const LiquidationEngine: React.FunctionComponent<LiquidationEngineProps> = ({
  filterStatus = false,
  orders,
  title,
  action,
  markets,
  loadName,
  loadCondition = true,
  sectionClass,
}: LiquidationEngineProps): ReactElement<LiquidationEngineProps> => {
  const [loading] = useTaskSubscriber(...loadName)

  return (
    <Section className={sectionClass} title={title}>
      <DataLoadSegment
        filter={filterStatus}
        loading={loading && loadCondition}
      >
        <ListTable>
          <TableHead>
            <TableRow>
              <TableCell>Order ID</TableCell>
              <TableCell>Market</TableCell>
              <TableCell>To Close</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="right">Quantity</TableCell>
              <TableCell align="right">Price</TableCell>
              <TableCell align="right">Created At</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {orders?.data.map((order) => (
              <LiquidationEngineRow key={order.id} order={order} markets={markets} />
            ))}
          </TableBody>
        </ListTable>
        {!!orders?.data?.length && (
          <Box marginTop={3}>
            <PaginationByIndex
              response={orders}
              action={action}
              filters={{}}
              useBlockHeight={false}
            />
          </Box>
        )}
        {!orders?.data?.length && (
          <TableEmptyState itemName={title.toLowerCase()} />
        )}
      </DataLoadSegment>
    </Section>
  )
}

export default LiquidationEngine
